/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import { View, Text, ScrollView } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import AnimatedTable from '@components/settings/components/common/animatedTable';
import Header from '@components/settings/v2/common/SettingsHeader';

import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import ColorWrapper from '@styles/colors';

import { useManageUsers } from './hooks/useManageUsers';
import { TEST_IDS } from '@v2/pages/common/constants/base.constants';

const { usersScreen } = TEST_IDS;

const Users = ({ C, toggleInviteUser, rootStack }) => {
  const {
    formattedUsers,
    formattedInvitedUsers,
    loaded,
    invitedLoaded,
    isUsersMore,
    isInvitedUsersMore,
    dispatchSearchUsers,
    dispatchSearchInvitedUsers,
    navigateToUserDetails,
  } = useManageUsers({ toggleInviteUser, C, rootStack });

  const ArrowComponent = () => {
    return (
      <View>
        <Svg icon="chevronRightLight" color="Label/Light/Quinary" width={scale(7)} height={scale(12)} />
      </View>
    );
  };

  return (
    <View
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      <Header name={'Users'} action={toggleInviteUser} />
      <ScrollView style={{ width: '100%', flex: 1 }} contentContainerStyle={{ paddingBottom: scale(50) }}>
        <View
          style={{
            paddingHorizontal: scale(18),
          }}
        >
          {!!formattedInvitedUsers.length && (
            <View testID={usersScreen.invitedSection}>
              <View style={{ paddingHorizontal: scale(15) }}>
                <Text
                  style={[
                    {
                      color: C('Label / Light / Primary'),
                      fontWeight: 'bold',
                    },
                    font['Title 2'],
                  ]}
                >
                  {i18n.t('INVITATION PENDING')}
                </Text>
              </View>
              <View style={{ marginTop: scale(18) }} testID={usersScreen.invitedTable}>
                <AnimatedTable
                  {...{
                    hideBorderForLastItem: true,
                    C,
                    array: formattedInvitedUsers,
                    onPress: (i) => navigateToUserDetails(i.id),
                    showMoreText: i18n.t('SHOW MORE USERS'),
                    showMoreArrow: false,
                    showAllButton: isInvitedUsersMore,
                    load: dispatchSearchInvitedUsers,
                    loaded: invitedLoaded,
                    config: [
                      {
                        key: 'name',
                        title: 'Name',
                        orderBy: 'FirstName',
                        sort: true,
                        width: '27.1%',
                        color: C('Label / Light / Primary'),
                        titleColor: C('Label / Light / Primary'),
                      },
                      {
                        key: 'email',
                        title: 'Email',
                        orderBy: 'emailAddress',
                        sort: true,
                        width: '33%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Primary'),
                      },
                      {
                        key: 'role',
                        title: 'Role',
                        orderBy: 'role',
                        sort: true,
                        width: '23%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Primary'),
                      },
                      {
                        key: 'invitedOn',
                        orderBy: 'invitedOn',
                        title: 'Invited on',
                        sort: true,
                        width: '16.9%',
                        color: C('Label / Light / Secondary'),
                        titleColor: C('Label / Light / Primary'),
                      },
                      {
                        function: ArrowComponent,
                        title: '',
                      },
                    ],
                  }}
                />
              </View>
            </View>
          )}
          <View testID={usersScreen.activeSection}>
            <View style={{ paddingHorizontal: scale(15), marginTop: scale(formattedInvitedUsers.length ? 30 : 0) }}>
              <Text
                style={[
                  {
                    color: C('Label / Light / Primary'),
                    fontWeight: 'bold',
                  },
                  font['Title 2'],
                ]}
              >
                {i18n.t('ACTIVE USERS')}
              </Text>
            </View>
            <View style={{ marginTop: scale(18) }} testID={usersScreen.activeTable}>
              <AnimatedTable
                {...{
                  hideBorderForLastItem: true,
                  C,
                  array: formattedUsers,
                  onPress: (i) => navigateToUserDetails(i.id),
                  showMoreText: i18n.t('SHOW MORE USERS'),
                  showMoreArrow: false,
                  showAllButton: isUsersMore,
                  load: dispatchSearchUsers,
                  loaded,
                  config: [
                    {
                      key: 'name',
                      title: 'Name',
                      orderBy: 'FirstName',
                      sort: true,
                      width: '27.1%',
                      color: C('Label / Light / Primary'),
                      titleColor: C('Label / Light / Primary'),
                    },
                    {
                      key: 'email',
                      title: 'Email',
                      orderBy: 'emailAddress',
                      sort: true,
                      width: '33%',
                      color: C('Label / Light / Secondary'),
                      titleColor: C('Label / Light / Primary'),
                    },
                    {
                      key: 'role',
                      title: 'Role',
                      orderBy: 'role',
                      sort: true,
                      width: '23%',
                      color: C('Label / Light / Secondary'),
                      titleColor: C('Label / Light / Primary'),
                    },
                    {
                      key: 'lastUsedOn',
                      orderBy: 'lastUsedOn',
                      title: 'Last use',
                      sort: true,
                      width: '16.9%',
                      color: C('Label / Light / Secondary'),
                      titleColor: C('Label / Light / Primary'),
                    },
                    {
                      function: ArrowComponent,
                      title: '',
                    },
                  ],
                }}
              />
            </View>
          </View>
        </View>
      </ScrollView>
    </View>
  );
};

export default ColorWrapper(Users);
